import { useState } from "react";
import "./Modal.css";

import ModalImage from "../../assets/svg/Modal.svg";
import BgImage from "../../assets/svg/Bg.svg";

import { createCreator } from "../../api/CreatorApi";

const Modal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setError("");
  };

  const isFormFilled =
    formData.name.trim() !== "" &&
    formData.phone.trim() !== "" &&
    formData.email.trim() !== "";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormFilled || loading) return;

    try {
      setLoading(true);
      setError("");

      const data = new FormData();

      data.append("name", formData.name.trim());
      data.append("phone_number", formData.phone.trim());
      data.append("email", formData.email.trim());

      await createCreator(data);

      setSuccess(true);

      setFormData({
        name: "",
        phone: "",
        email: "",
      });
    } catch (err) {
      console.error("Creator registration error:", err);

      const detail = err?.response?.data?.detail;

      if (Array.isArray(detail)) {
        setError(
          detail
            .map((item) => item?.msg || "Invalid input")
            .join(", ")
        );
      } else if (typeof detail === "string") {
        setError(detail);
      } else {
        setError(
          "Something went wrong. Please try again."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      name: "",
      phone: "",
      email: "",
    });

    setError("");
    setSuccess(false);
    setLoading(false);

    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal__overlay">
      <div
        className="modal"
        style={{ "--modal-bg": `url(${BgImage})` }}
      >
        {/* Header */}
        <div className="modal__header">
          <h2>Join the Waitlist</h2>

          <button
            type="button"
            className="modal__close"
            onClick={handleClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        {/* Illustration */}
        <div className="modal__image">
          <img src={ModalImage} alt="" />
        </div>

        {success ? (
          <div className="modal__success">
            <h3>You’re on the list!</h3>

            <p>
              Thanks for your interest in Xyncely.
              We’ll keep you updated.
            </p>

            <button
              type="button"
              className="modal__submit modal__submit--active"
              onClick={handleClose}
            >
              Done <span>→</span>
            </button>
          </div>
        ) : (
          <form
            className="modal__form"
            onSubmit={handleSubmit}
          >
            {/* Full Name */}
            <div className="modal__field">
              <label htmlFor="modal-name">
                Full Name <span>*</span>
              </label>

              <input
                id="modal-name"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="e.g. Alex Rivera"
                required
              />
            </div>

            {/* Phone */}
            <div className="modal__field">
              <label htmlFor="modal-phone">
                Phone Number <span>*</span>
              </label>

              <input
                id="modal-phone"
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="e.g. +1 (555) 000-0000"
                required
              />
            </div>

            {/* Email */}
            <div className="modal__field">
              <label htmlFor="modal-email">
                Email Address <span>*</span>
              </label>

              <input
                id="modal-email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="you@company.com"
                required
              />
            </div>

            {/* Consent */}
            <label className="modal__consent">
              <input type="checkbox" />

              <span>
                I agree to receive updates and marketing
                communications from{" "}
                <strong>Xyncely</strong>
              </span>
            </label>

            {error && (
              <p className="modal__error">
                {error}
              </p>
            )}

            {/* Submit */}
            <button
              type="submit"
              className={`modal__submit ${
                isFormFilled
                  ? "modal__submit--active"
                  : ""
              }`}
              disabled={!isFormFilled || loading}
            >
              {loading ? "Submitting..." : "Submit"}

              {!loading && <span>→</span>}
            </button>

            <p className="modal__privacy">
              We respect your privacy. No spam, ever.
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default Modal;